"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabellaUnoResourceApi = exports.TabellaUnoResourceApiFactory = exports.TabellaUnoResourceApiFp = exports.TabellaUnoResourceApiAxiosParamCreator = void 0;
/* tslint:disable */
/* eslint-disable */
/**
 * mspo-service API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var base_1 = require("../base");
/**
 * TabellaUnoResourceApi - axios parameter creator
 * @export
 */
exports.TabellaUnoResourceApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Cancellare una voce di prestazione dalla compilazione della tabella
         * @param {AggiornaSingolaVoceDettaglioDTO} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoCompilazioneAggiornaSingolaVoceTabellaDettaglioPut: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    localVarPath = "/mspo/tabellaUno/compilazioneAggiornaSingolaVoceTabellaDettaglio";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication SecurityScheme required
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.params) {
                        query.set(key, options.params[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Aggiungere una voce di prestazione alla compilazione della tabella
         * @param {SingolaVoceTabellaDettaglioDTO} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoCompilazioneAggiungiSingolaVoceTabellaDettaglioPut: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    localVarPath = "/mspo/tabellaUno/compilazioneAggiungiSingolaVoceTabellaDettaglio";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication SecurityScheme required
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.params) {
                        query.set(key, options.params[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Cancellare una voce di prestazione dalla compilazione della tabella
         * @param {CancellaSingolaVoceDettaglioDTO} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoCompilazioneCancellaSingolaVoceTabellaDettaglioPut: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    localVarPath = "/mspo/tabellaUno/compilazioneCancellaSingolaVoceTabellaDettaglio";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication SecurityScheme required
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.params) {
                        query.set(key, options.params[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Creazione della tabella uno da associazione nuova compilazione
         * @param {TabellaUnoCreateDTO} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoCreaNuovaTabellaPost: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    localVarPath = "/mspo/tabellaUno/creaNuovaTabella";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication SecurityScheme required
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.params) {
                        query.set(key, options.params[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary questo metodo prende in input due parametri: codice fiscale ed identificativo polizza corrente in compilazione      e restituisce l'elenco delle tabelle uno compilate e confermate diverse dalla polizza che si sta compilando.      In tal caso sulla compilazione l'identificativo della polizza sarà diverso da quella che si sta compilando.      In più restituisce anche le tabelle uno in compilazione corrente se esiste confermate o meno.      In questo modo l'utente può visualizzare un elenco di tabelle uno sulla dropdown di selezione e      decidere di applicarne una diversa se lo decide      occorre fare in modo che se l'utente cambia tabella e ne compila una nuova a partire da una compilazione      tabella diversa per quella corrente ne va creata una nuova in compilazione.      Inoltre sul metodo conferma tabella uno per quella in corso va fatto in modo che l'utente abbia solo una      tabella confermata per l'id polizza corrente impostando a zero quelle precedentemente confermate sulla stessa polizza      *_/
         * @param {RicercaElencoTabellaUnoDTO} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoElencoTabelleUnoByCodiceFiscalePost: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    localVarPath = "/mspo/tabellaUno/elencoTabelleUnoByCodiceFiscale";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication SecurityScheme required
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.params) {
                        query.set(key, options.params[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Ottenere una specifica tabella uno per codice fiscale compilante e assicurazione
         * @param {RichiestaTabellaUnoDTO} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoGetByPolizzaAndCodiceFiscalePost: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    localVarPath = "/mspo/tabellaUno/getByPolizzaAndCodiceFiscale";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication SecurityScheme required
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.params) {
                        query.set(key, options.params[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Ottenere informazioni su una tabella uno per codice tabella
         * @param {RicercaTabellaUnoByIdDTO} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoGetCompilazioneTabellaUnoByIdPost: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    localVarPath = "/mspo/tabellaUno/getCompilazioneTabellaUnoById";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication SecurityScheme required
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.params) {
                        query.set(key, options.params[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Ottenere informazioni su un dettaglio di una tabella uno per codice dettaglo
         * @param {RicercaDettaglioTabellaUnoByIdDTO} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoGetDettaglioTabellaUnoByIdPost: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    localVarPath = "/mspo/tabellaUno/getDettaglioTabellaUnoById";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication SecurityScheme required
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.params) {
                        query.set(key, options.params[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Confermare una tabella uno. Deprecato perchè la conferma avviene solo se la polizza è confermata?
         * @param {StringParam} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoInviaTabellaDefinitivaPost: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    localVarPath = "/mspo/tabellaUno/inviaTabellaDefinitiva";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication SecurityScheme required
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.params) {
                        query.set(key, options.params[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Recupero la tabella uno corrispondente e confermata data la polizza
         * @param {StringParam} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoRecuperoTabellaUnoByPolizzaPost: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    localVarPath = "/mspo/tabellaUno/recuperoTabellaUnoByPolizza";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication SecurityScheme required
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.params) {
                        query.set(key, options.params[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Recupero la tabella uno corrispondente e confermata data la polizza
         * @param {StringParam} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoRecuperoTabellaUnoDefinitivaDellaPolizzaPost: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    localVarPath = "/mspo/tabellaUno/recuperoTabellaUnoDefinitivaDellaPolizza";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication SecurityScheme required
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.params) {
                        query.set(key, options.params[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Aggiornamento voci di prestazione alla compilazione della tabella selezionata
         * @param {AggiornaVociTabellaUnoDTO} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoSalvaVociTabellaUnoPost: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    localVarPath = "/mspo/tabellaUno/salvaVociTabellaUno";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    // authentication SecurityScheme required
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.params) {
                        query.set(key, options.params[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * TabellaUnoResourceApi - functional programming interface
 * @export
 */
exports.TabellaUnoResourceApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Cancellare una voce di prestazione dalla compilazione della tabella
         * @param {AggiornaSingolaVoceDettaglioDTO} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoCompilazioneAggiornaSingolaVoceTabellaDettaglioPut: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.TabellaUnoResourceApiAxiosParamCreator(configuration).mspoTabellaUnoCompilazioneAggiornaSingolaVoceTabellaDettaglioPut(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Aggiungere una voce di prestazione alla compilazione della tabella
         * @param {SingolaVoceTabellaDettaglioDTO} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoCompilazioneAggiungiSingolaVoceTabellaDettaglioPut: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.TabellaUnoResourceApiAxiosParamCreator(configuration).mspoTabellaUnoCompilazioneAggiungiSingolaVoceTabellaDettaglioPut(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Cancellare una voce di prestazione dalla compilazione della tabella
         * @param {CancellaSingolaVoceDettaglioDTO} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoCompilazioneCancellaSingolaVoceTabellaDettaglioPut: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.TabellaUnoResourceApiAxiosParamCreator(configuration).mspoTabellaUnoCompilazioneCancellaSingolaVoceTabellaDettaglioPut(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Creazione della tabella uno da associazione nuova compilazione
         * @param {TabellaUnoCreateDTO} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoCreaNuovaTabellaPost: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.TabellaUnoResourceApiAxiosParamCreator(configuration).mspoTabellaUnoCreaNuovaTabellaPost(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary questo metodo prende in input due parametri: codice fiscale ed identificativo polizza corrente in compilazione      e restituisce l'elenco delle tabelle uno compilate e confermate diverse dalla polizza che si sta compilando.      In tal caso sulla compilazione l'identificativo della polizza sarà diverso da quella che si sta compilando.      In più restituisce anche le tabelle uno in compilazione corrente se esiste confermate o meno.      In questo modo l'utente può visualizzare un elenco di tabelle uno sulla dropdown di selezione e      decidere di applicarne una diversa se lo decide      occorre fare in modo che se l'utente cambia tabella e ne compila una nuova a partire da una compilazione      tabella diversa per quella corrente ne va creata una nuova in compilazione.      Inoltre sul metodo conferma tabella uno per quella in corso va fatto in modo che l'utente abbia solo una      tabella confermata per l'id polizza corrente impostando a zero quelle precedentemente confermate sulla stessa polizza      *_/
         * @param {RicercaElencoTabellaUnoDTO} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoElencoTabelleUnoByCodiceFiscalePost: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.TabellaUnoResourceApiAxiosParamCreator(configuration).mspoTabellaUnoElencoTabelleUnoByCodiceFiscalePost(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Ottenere una specifica tabella uno per codice fiscale compilante e assicurazione
         * @param {RichiestaTabellaUnoDTO} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoGetByPolizzaAndCodiceFiscalePost: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.TabellaUnoResourceApiAxiosParamCreator(configuration).mspoTabellaUnoGetByPolizzaAndCodiceFiscalePost(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Ottenere informazioni su una tabella uno per codice tabella
         * @param {RicercaTabellaUnoByIdDTO} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoGetCompilazioneTabellaUnoByIdPost: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.TabellaUnoResourceApiAxiosParamCreator(configuration).mspoTabellaUnoGetCompilazioneTabellaUnoByIdPost(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Ottenere informazioni su un dettaglio di una tabella uno per codice dettaglo
         * @param {RicercaDettaglioTabellaUnoByIdDTO} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoGetDettaglioTabellaUnoByIdPost: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.TabellaUnoResourceApiAxiosParamCreator(configuration).mspoTabellaUnoGetDettaglioTabellaUnoByIdPost(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Confermare una tabella uno. Deprecato perchè la conferma avviene solo se la polizza è confermata?
         * @param {StringParam} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoInviaTabellaDefinitivaPost: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.TabellaUnoResourceApiAxiosParamCreator(configuration).mspoTabellaUnoInviaTabellaDefinitivaPost(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Recupero la tabella uno corrispondente e confermata data la polizza
         * @param {StringParam} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoRecuperoTabellaUnoByPolizzaPost: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.TabellaUnoResourceApiAxiosParamCreator(configuration).mspoTabellaUnoRecuperoTabellaUnoByPolizzaPost(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Recupero la tabella uno corrispondente e confermata data la polizza
         * @param {StringParam} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoRecuperoTabellaUnoDefinitivaDellaPolizzaPost: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.TabellaUnoResourceApiAxiosParamCreator(configuration).mspoTabellaUnoRecuperoTabellaUnoDefinitivaDellaPolizzaPost(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Aggiornamento voci di prestazione alla compilazione della tabella selezionata
         * @param {AggiornaVociTabellaUnoDTO} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoSalvaVociTabellaUnoPost: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, exports.TabellaUnoResourceApiAxiosParamCreator(configuration).mspoTabellaUnoSalvaVociTabellaUnoPost(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = axios_1.default; }
                                    if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * TabellaUnoResourceApi - factory interface
 * @export
 */
exports.TabellaUnoResourceApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Cancellare una voce di prestazione dalla compilazione della tabella
         * @param {AggiornaSingolaVoceDettaglioDTO} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoCompilazioneAggiornaSingolaVoceTabellaDettaglioPut: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, exports.TabellaUnoResourceApiFp(configuration).mspoTabellaUnoCompilazioneAggiornaSingolaVoceTabellaDettaglioPut(body, options).then(function (request) { return request(axios, basePath); })];
                });
            });
        },
        /**
         *
         * @summary Aggiungere una voce di prestazione alla compilazione della tabella
         * @param {SingolaVoceTabellaDettaglioDTO} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoCompilazioneAggiungiSingolaVoceTabellaDettaglioPut: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, exports.TabellaUnoResourceApiFp(configuration).mspoTabellaUnoCompilazioneAggiungiSingolaVoceTabellaDettaglioPut(body, options).then(function (request) { return request(axios, basePath); })];
                });
            });
        },
        /**
         *
         * @summary Cancellare una voce di prestazione dalla compilazione della tabella
         * @param {CancellaSingolaVoceDettaglioDTO} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoCompilazioneCancellaSingolaVoceTabellaDettaglioPut: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, exports.TabellaUnoResourceApiFp(configuration).mspoTabellaUnoCompilazioneCancellaSingolaVoceTabellaDettaglioPut(body, options).then(function (request) { return request(axios, basePath); })];
                });
            });
        },
        /**
         *
         * @summary Creazione della tabella uno da associazione nuova compilazione
         * @param {TabellaUnoCreateDTO} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoCreaNuovaTabellaPost: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, exports.TabellaUnoResourceApiFp(configuration).mspoTabellaUnoCreaNuovaTabellaPost(body, options).then(function (request) { return request(axios, basePath); })];
                });
            });
        },
        /**
         *
         * @summary questo metodo prende in input due parametri: codice fiscale ed identificativo polizza corrente in compilazione      e restituisce l'elenco delle tabelle uno compilate e confermate diverse dalla polizza che si sta compilando.      In tal caso sulla compilazione l'identificativo della polizza sarà diverso da quella che si sta compilando.      In più restituisce anche le tabelle uno in compilazione corrente se esiste confermate o meno.      In questo modo l'utente può visualizzare un elenco di tabelle uno sulla dropdown di selezione e      decidere di applicarne una diversa se lo decide      occorre fare in modo che se l'utente cambia tabella e ne compila una nuova a partire da una compilazione      tabella diversa per quella corrente ne va creata una nuova in compilazione.      Inoltre sul metodo conferma tabella uno per quella in corso va fatto in modo che l'utente abbia solo una      tabella confermata per l'id polizza corrente impostando a zero quelle precedentemente confermate sulla stessa polizza      *_/
         * @param {RicercaElencoTabellaUnoDTO} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoElencoTabelleUnoByCodiceFiscalePost: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, exports.TabellaUnoResourceApiFp(configuration).mspoTabellaUnoElencoTabelleUnoByCodiceFiscalePost(body, options).then(function (request) { return request(axios, basePath); })];
                });
            });
        },
        /**
         *
         * @summary Ottenere una specifica tabella uno per codice fiscale compilante e assicurazione
         * @param {RichiestaTabellaUnoDTO} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoGetByPolizzaAndCodiceFiscalePost: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, exports.TabellaUnoResourceApiFp(configuration).mspoTabellaUnoGetByPolizzaAndCodiceFiscalePost(body, options).then(function (request) { return request(axios, basePath); })];
                });
            });
        },
        /**
         *
         * @summary Ottenere informazioni su una tabella uno per codice tabella
         * @param {RicercaTabellaUnoByIdDTO} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoGetCompilazioneTabellaUnoByIdPost: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, exports.TabellaUnoResourceApiFp(configuration).mspoTabellaUnoGetCompilazioneTabellaUnoByIdPost(body, options).then(function (request) { return request(axios, basePath); })];
                });
            });
        },
        /**
         *
         * @summary Ottenere informazioni su un dettaglio di una tabella uno per codice dettaglo
         * @param {RicercaDettaglioTabellaUnoByIdDTO} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoGetDettaglioTabellaUnoByIdPost: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, exports.TabellaUnoResourceApiFp(configuration).mspoTabellaUnoGetDettaglioTabellaUnoByIdPost(body, options).then(function (request) { return request(axios, basePath); })];
                });
            });
        },
        /**
         *
         * @summary Confermare una tabella uno. Deprecato perchè la conferma avviene solo se la polizza è confermata?
         * @param {StringParam} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoInviaTabellaDefinitivaPost: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, exports.TabellaUnoResourceApiFp(configuration).mspoTabellaUnoInviaTabellaDefinitivaPost(body, options).then(function (request) { return request(axios, basePath); })];
                });
            });
        },
        /**
         *
         * @summary Recupero la tabella uno corrispondente e confermata data la polizza
         * @param {StringParam} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoRecuperoTabellaUnoByPolizzaPost: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, exports.TabellaUnoResourceApiFp(configuration).mspoTabellaUnoRecuperoTabellaUnoByPolizzaPost(body, options).then(function (request) { return request(axios, basePath); })];
                });
            });
        },
        /**
         *
         * @summary Recupero la tabella uno corrispondente e confermata data la polizza
         * @param {StringParam} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoRecuperoTabellaUnoDefinitivaDellaPolizzaPost: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, exports.TabellaUnoResourceApiFp(configuration).mspoTabellaUnoRecuperoTabellaUnoDefinitivaDellaPolizzaPost(body, options).then(function (request) { return request(axios, basePath); })];
                });
            });
        },
        /**
         *
         * @summary Aggiornamento voci di prestazione alla compilazione della tabella selezionata
         * @param {AggiornaVociTabellaUnoDTO} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mspoTabellaUnoSalvaVociTabellaUnoPost: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, exports.TabellaUnoResourceApiFp(configuration).mspoTabellaUnoSalvaVociTabellaUnoPost(body, options).then(function (request) { return request(axios, basePath); })];
                });
            });
        },
    };
};
/**
 * TabellaUnoResourceApi - object-oriented interface
 * @export
 * @class TabellaUnoResourceApi
 * @extends {BaseAPI}
 */
var TabellaUnoResourceApi = /** @class */ (function (_super) {
    __extends(TabellaUnoResourceApi, _super);
    function TabellaUnoResourceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Cancellare una voce di prestazione dalla compilazione della tabella
     * @param {AggiornaSingolaVoceDettaglioDTO} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TabellaUnoResourceApi
     */
    TabellaUnoResourceApi.prototype.mspoTabellaUnoCompilazioneAggiornaSingolaVoceTabellaDettaglioPut = function (body, options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, exports.TabellaUnoResourceApiFp(this.configuration).mspoTabellaUnoCompilazioneAggiornaSingolaVoceTabellaDettaglioPut(body, options).then(function (request) { return request(_this.axios, _this.basePath); })];
            });
        });
    };
    /**
     *
     * @summary Aggiungere una voce di prestazione alla compilazione della tabella
     * @param {SingolaVoceTabellaDettaglioDTO} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TabellaUnoResourceApi
     */
    TabellaUnoResourceApi.prototype.mspoTabellaUnoCompilazioneAggiungiSingolaVoceTabellaDettaglioPut = function (body, options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, exports.TabellaUnoResourceApiFp(this.configuration).mspoTabellaUnoCompilazioneAggiungiSingolaVoceTabellaDettaglioPut(body, options).then(function (request) { return request(_this.axios, _this.basePath); })];
            });
        });
    };
    /**
     *
     * @summary Cancellare una voce di prestazione dalla compilazione della tabella
     * @param {CancellaSingolaVoceDettaglioDTO} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TabellaUnoResourceApi
     */
    TabellaUnoResourceApi.prototype.mspoTabellaUnoCompilazioneCancellaSingolaVoceTabellaDettaglioPut = function (body, options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, exports.TabellaUnoResourceApiFp(this.configuration).mspoTabellaUnoCompilazioneCancellaSingolaVoceTabellaDettaglioPut(body, options).then(function (request) { return request(_this.axios, _this.basePath); })];
            });
        });
    };
    /**
     *
     * @summary Creazione della tabella uno da associazione nuova compilazione
     * @param {TabellaUnoCreateDTO} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TabellaUnoResourceApi
     */
    TabellaUnoResourceApi.prototype.mspoTabellaUnoCreaNuovaTabellaPost = function (body, options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, exports.TabellaUnoResourceApiFp(this.configuration).mspoTabellaUnoCreaNuovaTabellaPost(body, options).then(function (request) { return request(_this.axios, _this.basePath); })];
            });
        });
    };
    /**
     *
     * @summary questo metodo prende in input due parametri: codice fiscale ed identificativo polizza corrente in compilazione      e restituisce l'elenco delle tabelle uno compilate e confermate diverse dalla polizza che si sta compilando.      In tal caso sulla compilazione l'identificativo della polizza sarà diverso da quella che si sta compilando.      In più restituisce anche le tabelle uno in compilazione corrente se esiste confermate o meno.      In questo modo l'utente può visualizzare un elenco di tabelle uno sulla dropdown di selezione e      decidere di applicarne una diversa se lo decide      occorre fare in modo che se l'utente cambia tabella e ne compila una nuova a partire da una compilazione      tabella diversa per quella corrente ne va creata una nuova in compilazione.      Inoltre sul metodo conferma tabella uno per quella in corso va fatto in modo che l'utente abbia solo una      tabella confermata per l'id polizza corrente impostando a zero quelle precedentemente confermate sulla stessa polizza      *_/
     * @param {RicercaElencoTabellaUnoDTO} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TabellaUnoResourceApi
     */
    TabellaUnoResourceApi.prototype.mspoTabellaUnoElencoTabelleUnoByCodiceFiscalePost = function (body, options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, exports.TabellaUnoResourceApiFp(this.configuration).mspoTabellaUnoElencoTabelleUnoByCodiceFiscalePost(body, options).then(function (request) { return request(_this.axios, _this.basePath); })];
            });
        });
    };
    /**
     *
     * @summary Ottenere una specifica tabella uno per codice fiscale compilante e assicurazione
     * @param {RichiestaTabellaUnoDTO} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TabellaUnoResourceApi
     */
    TabellaUnoResourceApi.prototype.mspoTabellaUnoGetByPolizzaAndCodiceFiscalePost = function (body, options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, exports.TabellaUnoResourceApiFp(this.configuration).mspoTabellaUnoGetByPolizzaAndCodiceFiscalePost(body, options).then(function (request) { return request(_this.axios, _this.basePath); })];
            });
        });
    };
    /**
     *
     * @summary Ottenere informazioni su una tabella uno per codice tabella
     * @param {RicercaTabellaUnoByIdDTO} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TabellaUnoResourceApi
     */
    TabellaUnoResourceApi.prototype.mspoTabellaUnoGetCompilazioneTabellaUnoByIdPost = function (body, options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, exports.TabellaUnoResourceApiFp(this.configuration).mspoTabellaUnoGetCompilazioneTabellaUnoByIdPost(body, options).then(function (request) { return request(_this.axios, _this.basePath); })];
            });
        });
    };
    /**
     *
     * @summary Ottenere informazioni su un dettaglio di una tabella uno per codice dettaglo
     * @param {RicercaDettaglioTabellaUnoByIdDTO} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TabellaUnoResourceApi
     */
    TabellaUnoResourceApi.prototype.mspoTabellaUnoGetDettaglioTabellaUnoByIdPost = function (body, options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, exports.TabellaUnoResourceApiFp(this.configuration).mspoTabellaUnoGetDettaglioTabellaUnoByIdPost(body, options).then(function (request) { return request(_this.axios, _this.basePath); })];
            });
        });
    };
    /**
     *
     * @summary Confermare una tabella uno. Deprecato perchè la conferma avviene solo se la polizza è confermata?
     * @param {StringParam} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TabellaUnoResourceApi
     */
    TabellaUnoResourceApi.prototype.mspoTabellaUnoInviaTabellaDefinitivaPost = function (body, options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, exports.TabellaUnoResourceApiFp(this.configuration).mspoTabellaUnoInviaTabellaDefinitivaPost(body, options).then(function (request) { return request(_this.axios, _this.basePath); })];
            });
        });
    };
    /**
     *
     * @summary Recupero la tabella uno corrispondente e confermata data la polizza
     * @param {StringParam} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TabellaUnoResourceApi
     */
    TabellaUnoResourceApi.prototype.mspoTabellaUnoRecuperoTabellaUnoByPolizzaPost = function (body, options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, exports.TabellaUnoResourceApiFp(this.configuration).mspoTabellaUnoRecuperoTabellaUnoByPolizzaPost(body, options).then(function (request) { return request(_this.axios, _this.basePath); })];
            });
        });
    };
    /**
     *
     * @summary Recupero la tabella uno corrispondente e confermata data la polizza
     * @param {StringParam} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TabellaUnoResourceApi
     */
    TabellaUnoResourceApi.prototype.mspoTabellaUnoRecuperoTabellaUnoDefinitivaDellaPolizzaPost = function (body, options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, exports.TabellaUnoResourceApiFp(this.configuration).mspoTabellaUnoRecuperoTabellaUnoDefinitivaDellaPolizzaPost(body, options).then(function (request) { return request(_this.axios, _this.basePath); })];
            });
        });
    };
    /**
     *
     * @summary Aggiornamento voci di prestazione alla compilazione della tabella selezionata
     * @param {AggiornaVociTabellaUnoDTO} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TabellaUnoResourceApi
     */
    TabellaUnoResourceApi.prototype.mspoTabellaUnoSalvaVociTabellaUnoPost = function (body, options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, exports.TabellaUnoResourceApiFp(this.configuration).mspoTabellaUnoSalvaVociTabellaUnoPost(body, options).then(function (request) { return request(_this.axios, _this.basePath); })];
            });
        });
    };
    return TabellaUnoResourceApi;
}(base_1.BaseAPI));
exports.TabellaUnoResourceApi = TabellaUnoResourceApi;
